import "./RecepDocs.css";
import React, {useEffect, useState} from "react";
import Report from "../../Components/Report/Report";
import MySelect from "../../Components/MySelect/MySelect";
import MyDataTable from "../../Components/MyDataTable/MyDataTable";
import { useUserActions } from "../../../Connect/_actions";
import Collection from "../../Model/Collection";
import Affaire from "../../Model/Affaire";
import Navette from "../../Model/Navette";
import CollectionParAffaire from "../../Model/CollectionsParAffaire";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { areCollectionsLoadedAtom, collectionsAtom, isAlertCollectionsOpenAtom, isAlertContractsOpenAtom, isListCollectionsByAffaireLoadedAtom, justDownloadedCollectionsAtom, listCollectionsByAffaireAtom, recentCollectionsAtom } from "../../LoadData/LoadData";
import { userAtom } from "../../RecoilApp";
import Loc from "../../../Loc/Loc";

export default function RecepDocs () {
    const setAreCollectionsLoaded = useSetRecoilState(areCollectionsLoadedAtom);
    const listCollectionsByContract = useRecoilValue(listCollectionsByAffaireAtom);
    const [isAlertContractsOpen, setStateAlertContracts] = useRecoilState(isAlertContractsOpenAtom);
    const [isAlertCollectionsOpen, setStateAlertCollections] = useRecoilState(isAlertCollectionsOpenAtom);
    const isListCollectionsByAffaireLoaded = useRecoilValue(isListCollectionsByAffaireLoadedAtom);
    const recentCollections = useRecoilValue(recentCollectionsAtom);
    const justDownloadedCollections = useRecoilValue(justDownloadedCollectionsAtom);
    const [collections, setCollections] = useRecoilState(collectionsAtom);
    const areCollectionsLoaded = useRecoilValue(areCollectionsLoadedAtom);
    const user = useRecoilValue(userAtom);
    const userActions = useUserActions();
    const [error, setError] = useState("");
    const [textInput, setTextInput] = useState("");
    const [notRecepOnly, setNotRecepState] = useState(false);
    const [selectedContract, setSelectedContract] = useState(Loc.trad().RecepDocsContractsAll);
    const [display, setDisplay] = useState(Loc.trad().RecepDocsShowAll);
    const [isRecentState, setIsRecentState] = useState(false);
    const [canSwitchDownloadSelect, setStateSwitchDownloadSelect] = useState(true);

    useEffect(() => {
        if (((Loc.select().map(l => l.RecepDocsShowUndownloaded).includes(display) && isRecentState === false) || (Loc.select().map(l => l.RecepDocsShowAll).includes(display) && isRecentState === true))
            && canSwitchDownloadSelect) {
            setIsRecentState(!isRecentState);
        }
    }, [display, isRecentState, canSwitchDownloadSelect])

    const RefreshCollections = () => {
        setCollections([]);
        setAreCollectionsLoaded(false);
        setStateAlertCollections(true);
        setStateSwitchDownloadSelect(false);
        setError("");
        userActions.getCollections(new Affaire())
            .then((collections) => {
                userActions.updateCollections(collections, setAreCollectionsLoaded, setStateSwitchDownloadSelect);
            })
            .catch((error) => {
                setError(error);
            })
    }

    const HandleChangeInput = (event: React.ChangeEvent<HTMLInputElement>) => {
        setTextInput(event.target.value);
    }

    const HandleSwitchBoxOnChange = () => {
        setNotRecepState(!notRecepOnly);
    }

    const addNotRecepFilter = (collections: Collection[]) => {
        if (!notRecepOnly) {
            return collections;
        }
        let filered_collections: Collection[] = [];
        collections.forEach((collection: Collection) => {
            let addToFilteredCollections: boolean = false;
            collection.navettes.forEach((navette: Navette) => {
                if (navette.retourClient === "") {
                    addToFilteredCollections = true;
                }
            })
            if (addToFilteredCollections) {
                filered_collections.push(collection);
            }
        })
        return filered_collections;
    }

    const addRecentFilter = (collections: Collection[]) => {
        if (!isRecentState) {
            return collections;
        }
        let filtered: Collection[] = [];
        let downloadedCollections: Collection[] = [];
        recentCollections.forEach((recent: Collection) => {
            let isDL: boolean = false;
            justDownloadedCollections.forEach((justDL: Collection) => {
                if (justDL.id === recent.id) {
                    isDL = true;
                }
            })
            if (!isDL) {
                downloadedCollections.push(recent);
            }
        })
        collections.forEach((collection: Collection) => {
            downloadedCollections.forEach((recent) => {
                if (recent.id === collection.id) {
                    filtered.push(collection);
                }
            })
        })
        return filtered;
    }

    const addContractFilter = (collections: Collection[]) => {
        if (Loc.select().map(l => l.RecepDocsContractsAll).includes(selectedContract)) {
            return collections;
        }
        let id_collections: number[] = [];
        listCollectionsByContract.forEach((CollectionsByContract: CollectionParAffaire) => {
            if (selectedContract === CollectionsByContract.affaire.libelle) {
                id_collections = CollectionsByContract.collections.map((collection: Collection) => {return collection.id})
            }
        })
        let filtered: Collection[] = [];
        collections.forEach((collection: Collection) => {
            id_collections.forEach((id_collection) => {
                if (collection.id === id_collection) {
                    filtered.push(collection);
                }
            })
        })
        return filtered;
    }

    const define_categories = (collections: Collection[]) => {
        if (collections.length > 0) {
            return collections[0].colCategories;
        }
        return [];
    }

    const customStyles = {
        rows: {
            style: {
                background: "white"
            },
        }
    };

    return (
        <div>
            <div className="RecepDocs">
                <div>{Loc.trad().RecepDocsRecipient} <span style={{ color: "#AF007C" }}>{user.recipient}</span></div>
                <div className="Row">
                    <MySelect title={Loc.trad().RecepDocsContracts} options={listCollectionsByContract.map(contract => {return (Loc.select().map(l => l.RecepDocsContractsAll).includes(contract.affaire.libelle) ? Loc.trad().RecepDocsContractsAll : contract.affaire.libelle)})} sendDocForm={false} setOption={setSelectedContract}></MySelect>
                    <MySelect title={Loc.trad().RecepDocsShow} options={[Loc.trad().RecepDocsShowAll, Loc.trad().RecepDocsShowUndownloaded]} sendDocForm={false} setOption={setDisplay}></MySelect>
                </div>
                <div className="form-check form-switch" style={{marginTop: "15px", marginBottom: "15px"}}>
                    <input className="form-check-input" type="checkbox" id="NotRecep" onChange={HandleSwitchBoxOnChange} checked={notRecepOnly}/>
                    <label className="form-check-label" htmlFor="NotRecep">{Loc.trad().RecepDocsShowRadio}</label>
                </div>
                {
                    isListCollectionsByAffaireLoaded ?
                    <div>{isAlertContractsOpen && <div style={{marginTop: "14px"}} className="alert alert-success" role="alert">{Loc.trad().RecepDocsContractsUpToDate} ✅ <button onClick={() => setStateAlertContracts(false)} type="button" className="btn btn-outline-secondary">Ok</button></div>}</div> :
                    <div style={{marginTop: "14px"}} className="alert alert-secondary" role="alert">{Loc.trad().RecepDocsContractsLoad}<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div>
                }
                <div className="datatableInfos">
                    {
                        collections.length > 0 || areCollectionsLoaded ?
                            <div>
                                {
                                    areCollectionsLoaded ?
                                        <div>{isAlertCollectionsOpen && <div className="alert alert-success" role="alert" style={{ marginTop: "14px" }}>{Loc.trad().RecepDocsCollectionUpToDate} ✅ <button onClick={() => setStateAlertCollections(false)} type="button" className="btn btn-outline-secondary">Ok</button></div>}</div> :
                                    <div className="alert alert-secondary" style={{ marginTop: "14px" }} role="alert">{Loc.trad().RecepDocsCollectionLoad}<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div>
                                }
                                <div className="row">
                                    <div className="col col-md-3">
                                        <input type="text" className="form-control mb-2" placeholder={Loc.trad().RecepDocsSearch} value={textInput} onChange={HandleChangeInput} style={{ marginBottom: "1vh" }} />
                                    </div>
                                    {
                                        collections.length > 0 || areCollectionsLoaded ?
                                        <div className="col text-right">
                                            <button className="btn btn-primary mb-2" type="button" onClick={RefreshCollections}>
                                                {Loc.trad().RecepDocsRefresh}
                                            </button>
                                        </div> :
                                        <div className="col text-right">
                                            <button className="btn btn-primary mb-2" type="button" disabled>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                {Loc.trad().RecepDocsRefresh}
                                            </button>
                                        </div>
                                    }
                                </div>
                                <div className="datatableCollections"><MyDataTable title={Loc.trad().RecepDocsCollection}
                                    categories={define_categories(collections)}
                                    data={addContractFilter(addRecentFilter(addNotRecepFilter(collections)))}
                                    filter={textInput}
                                    expandable={true}
                                    pagination={true}
                                    selectable={true}
                                    background={"#ececec"}
                                    element={"Collections"}
                                    customStyles={customStyles}></MyDataTable></div>
                            </div> :
                        <div className="loading">{Loc.trad().RecepDocsCollectionLoad2} <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></div>
                    }
                    <div style={{color: "red"}}>{error}</div>
                </div>
            </div>
            <Report></Report>
        </div>
    )
}